'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _nav = require('./nav');

var _nav2 = _interopRequireDefault(_nav);

var _search = require('./search.vue');

var _search2 = _interopRequireDefault(_search);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

var _imagePath = require('@/mixins/image-path');

var _imagePath2 = _interopRequireDefault(_imagePath);

var _lodash = require('lodash');

var _isLogin = require('@/mixins/isLogin');

var _isLogin2 = _interopRequireDefault(_isLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_imagePath2.default, _isLogin2.default],
  provide: function provide() {
    return {
      setVisible: this.setVisible
    };
  },
  data: function data() {
    return {
      headImg: '',
      userName: '',
      userType: '',
      jzjyUrl: '',
      scrollTop: 0,
      showWhite: false,
      isLogining: '',
      imgUrl: '',
      isShowInfo: true,
      defaultImg: require('@/static/images/user/header-3.png')
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    loginSuccessNotify: function loginSuccessNotify(state) {
      return state.loginSuccessNotify;
    }
  }), (0, _vuex.mapGetters)(['userChangeInfo', 'flushContent'])),
  watch: {
    loginSuccessNotify: {
      handler: function handler(value) {
        if (value === 'NOTIFY_LOGIN_SUCCESS_REFRESH_USER_INFO') {
          this.getCurrentUser();
        }
      }
    },
    watch: {
      '$store.state.flushContent': function $storeStateFlushContent(val) {
        if (val && val == 'login') {
          this.$refs.loginModal.open();
        }
      }
    },
    flushContent: {
      handler: function handler(val) {
        var token = sessionStorage.getItem('authLogin') || localStorage.getItem('authLogin');
        if (token && token != 'null') {
          this.isLogining = true;
        } else {
          this.isLogining = false;
        }
      }
    },
    userChangeInfo: {
      handler: function handler(val) {
        this.userName = val.userName;
        this.getImgSrc('headImg', 'headImg', val.headImg);
      }
    },
    '$route.path': function $routePath() {
      this.initActiveNav();
    },
    '$route.fullPath': function $routeFullPath() {
      this.showDom();
    }
  },
  mounted: function mounted() {
    this.debounceScroll = (0, _lodash.debounce)(this.scrollFn, 200);
    window.addEventListener('scroll', this.debounceScroll);
    document.querySelector('.iv-header') && document.querySelector('.iv-header').addEventListener('mouseenter', this.eventMouseEnter);
    document.querySelector('.iv-header') && document.querySelector('.iv-header').addEventListener('mouseleave', this.eventMouseLeave);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.debounceScroll);
    document.querySelector('.iv-header') && document.querySelector('.iv-header').removeEventListener('mouseenter', this.eventMouseEnter);
    document.querySelector('.iv-header') && document.querySelector('.iv-header').removeEventListener('mouseleave', this.eventMouseLeave);
    this.$Message.destroy();
  },
  created: function created() {
    var _this = this;

    this.showDom();
    // let token = sessionStorage.getItem('authLogin')
    // if (token && token != 'null') {
    //   this.getCurrentUser()
    // }
    setTimeout(function () {
      var token = sessionStorage.getItem('authLogin') || localStorage.getItem('authLogin');
      var isShowHead = !_store2.default.state.hideRouterName.includes(_this.$route.name);
      if (token && token != 'null') {
        _this.isLogining = true;
      } else {
        _this.isLogining = false;
      }
      if (token && token != 'null' && isShowHead) {
        _this.getCurrentUser();
        _this.findDictList();
      }
    }, 100);
    this.initActiveNav();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['USER_CHANGE_INFO']), {
    handleError: function handleError(event) {
      event.target.src = this.defaultImg;
    },
    showDom: function showDom() {
      // 不登陆的页面不显示菜单 姓名
      var isnoShowInfo = ['microLesson-whitelist', 'pdfpreview'];
      this.isShowInfo = true;
      if (isnoShowInfo.includes(this.$route.name)) {
        this.isShowInfo = false;
      }
    },

    //监听鼠标进入
    eventMouseEnter: function eventMouseEnter() {
      this.showWhite = true;
    },
    eventMouseLeave: function eventMouseLeave() {
      this.initShowWhite();
    },

    //监听滚动
    scrollFn: function scrollFn(event) {
      this.scrollTop = window.scrollY;
    },

    // 下拉菜单点击事件
    onDropOperator: function onDropOperator(name) {
      switch (name) {
        case 'read':
          if (!this.isLogin('login')) return;
          this.userClick(0);
          break;
        case 'edit-square':
          if (!this.isLogin('login')) return;
          this.userClick(1);
          break;
        case 'contacts':
          if (!this.isLogin('login')) return;
          this.userClick(2);
          break;
        case 'poweroff':
          this.signOut();
          break;
        default:
          break;
      }
    },
    initActiveNav: function initActiveNav() {
      var matched = this.$route.matched;

      if (matched && matched.length) {
        this.activeVal = matched[0].name;
      } else {
        this.activeVal = 'index';
      }
      this.initShowWhite();
    },
    initShowWhite: function initShowWhite() {
      var name = this.$route.name;

      var _menuFilter = ['index'
      // 'applicationRecommend-list',
      // 'applicationRecommend-detail',
      // 'microLesson-list',
      // 'microLesson-whitelist',
      // 'microLesson-detail',
      // 'workVideo-list',
      // 'workVideo-detail',
      // 'course-list',
      // 'course-detail',
      // 'mystudy-list',
      // 'mystudy-detail',
      // 'jingcaizhibo-list',
      // 'nopermission',
      // 'broadcastReplay'
      ];
      //消息、待办特殊处理
      if (_menuFilter.includes(name)) {
        this.showWhite = false;
      } else {
        this.showWhite = true;
      }
    },

    // 跳转到家长教育
    jumpJZJY: function jumpJZJY() {
      window.open(this.jzjyUrl, '_blank');
    },
    findDictList: function findDictList() {
      var _this2 = this;

      this.$ajax({
        url: 'api-basic/portal/open/dicttype/findDictList?typeCodes=BJOU_JZJYPT',
        method: 'GET'
      }).then(function (res) {
        if (res.data.code == 2000) {
          _this2.jzjyUrl = res.data.data[0];
          var _arr = res.data.data && res.data.data[0];
          if (_arr && _arr.dicts && _arr.dicts.length) {
            _this2.jzjyUrl = (_arr.dicts[0] || {}).dictName;
          }
        }
      });
    },

    //获取当前用户信息
    getCurrentUser: function getCurrentUser() {
      var _this3 = this;

      this.$ajax({
        url: 'api-ouser/portal/user/getCurrentUser',
        type: 'GET'
      }).then(function (_ref) {
        var data = _ref.data;

        _this3.userName = data.data.name;
        _this3.userType = data.data.userType;
        if (data.data.userType == 3) {
          _this3.USER_CHANGE_INFO({
            userName: data.data.name,
            headImg: data.data.headImg
          });
        } else {
          _this3.USER_CHANGE_INFO({
            userName: data.data.name
          });
          _this3.imgUrl = 'api-course/serviceProvision/userPhoto?userId=' + data.data.userId;
        }
      });
    },

    // 联系我们
    jumpAbout: function jumpAbout() {
      this.toToBottom();
      // let routeUrl = this.$router.resolve({
      //   name: 'concatDetail'
      // })
      // window.open(routeUrl.href, '_blank')
    },
    toToBottom: function toToBottom() {
      var _this4 = this;

      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      var scrollHt = document.body.scrollHeight || document.documentElement.scrollHeight;
      var scrollBot = document.body.offsetHeight || document.documentElement.offsetHeight;
      if (scrollHt - scrollBot + 50 <= scrollTop) return;
      var nextFrame = this.nextFrame;
      window.scrollTo(0, scrollTop + 100);
      nextFrame(function () {
        _this4.toToBottom();
      });
    },
    nextFrame: function nextFrame(fn) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        fn.call(_this5);
      });
    },

    // 跳转个人中心
    userClick: function userClick(name) {
      this.$router.push({
        path: '/mystudy/mystudy-list',
        query: {
          name: name
        }
      });
    },

    // 跳转修改密码
    jumpReset: function jumpReset() {
      // this.$router.push({
      //   name: 'resetPasswords'
      // })
      this.$router.push({
        name: 'mytoonaccount'
      });
    },

    // 注册跳转
    jumpRegister: function jumpRegister() {
      this.$router.push({
        name: 'registerPhone',
        query: {
          from: this.$route.name
        }
      });
      // this.$store.commit('FLUSHCONTENT', '正在进行注册，点击确定刷新注册登录状态！')
      // let routeUrl = this.$router.resolve({
      //   name: 'toonLogin',
      //   query: {
      //     type: 'bind'
      //   }
      // })
      // window.open(routeUrl.href, '_blank')
    },

    // 登录跳转
    jumpLogin: function jumpLogin(type) {
      // type 个人登录1 单位登录2
      sessionStorage.gotoQueryPage = '/';
      this.$store.commit('FLUSHCONTENT', 'login');
      // this.$router.push({
      //   name: 'login',
      //   query: {
      //     type: 'header'
      //   }
      // })
      // this.$store.commit('FLUSHCONTENT', '正在进行登录，点击确定刷新登录状态！')
      // let routeUrl = this.$router.resolve({
      //   name: 'toonLogin',
      //   query: {
      //     type: 'bind'
      //   }
      // })
      // window.open(routeUrl.href, '_blank')
    },

    //退出
    signOut: function signOut() {
      var _this6 = this;

      this.$ajax({
        url: 'logout',
        type: 'GET'
      }).then(function (res) {
        var searchCourseNames = localStorage.getItem('searchCourseNames') || '';
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('searchCourseNames', searchCourseNames);
        _this6.$Message.success(_this6.$t('login.logout'));
        location.reload();
      });
    }
  }),
  components: {
    IconFont: _iconfont2.default,
    Nav: _nav2.default,
    search: _search2.default
  }
};
// import { indexRouter } from '@/config'